import { BrowserFrame, DashboardMockup } from './svg';
import { Zap, Eye, Bell } from 'lucide-react';

const features = [
  {
    icon: Zap,
    title: 'Real-Time Updates',
    description: 'Positions update live as trades execute',
  },
  {
    icon: Eye,
    title: 'Visual Utilization',
    description: 'Color-coded progress bars show limit usage',
  },
  {
    icon: Bell,
    title: 'Instant Alerts',
    description: 'Get notified before breaches happen',
  },
];

export function DashboardShowcaseSection() {
  return (
    <section className="relative py-20 md:py-28 bg-slate-900">
      <div className="container relative">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4 text-white">
            See Your Positions{' '}
            <span className="text-purple-400">
              at a Glance
            </span>
          </h2>
          <p className="text-lg text-white/70">
            Our intuitive dashboard gives you real-time visibility into all your positions, limits, and compliance status.
          </p>
        </div>

        {/* Dashboard Preview */}
        <div className="mx-auto max-w-5xl relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10">
            <BrowserFrame className="bg-slate-800">
              <DashboardMockup />
            </BrowserFrame>
          </div>
        </div>

        {/* Feature Highlights */}
        <div className="mt-16 grid gap-6 sm:grid-cols-3 max-w-4xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="text-center p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
            >
              <div className="inline-flex rounded-xl bg-purple-600 p-3 mb-4">
                <feature.icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="font-semibold mb-1 text-white">{feature.title}</h3>
              <p className="text-sm text-white/60">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
